import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import { Pagination } from '@mui/material';
import axios from '../../helpers/axios';
import { isUatEnvironment } from '../../helpers/uatMasking';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Avatar, Menu, MenuItem, Typography, FormControl, OutlinedInput, TextField, CardActions, Modal, Box, Select, InputLabel, Divider, Backdrop, CircularProgress, Dialog, DialogTitle, DialogActions } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
// import Customers from './Customers';
import NeighbourhoodHeader from './NeighbourhoodHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers';
import debounce from 'lodash.debounce';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};
function CustomPagination({ count, page, onChange }: { count: number, page: number, onChange: (event: React.ChangeEvent<unknown>, value: number) => void }) {
    return (
        <Pagination
            count={count}
            page={page}
            onChange={onChange}
            color="primary"
            shape="rounded"
            variant="outlined"
            showFirstButton
            showLastButton
        
        
        
        />
    );
}

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    pageSize: number;
    filter: any;
    showLoader: boolean;
    anchorEl: any;
    inactive_registrations_data: any;
    community_id: any;
    rowCount: any;
    toggleCustomerId: any;
    showDialogBox: boolean;
    toggleCustomerStatus: any;
    currentPage: number
}

class InactiveRegistrations extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            pageSize: 10,
            filter: '',
            showLoader: false,
            anchorEl: null,
            inactive_registrations_data: [],
            community_id: '',
            rowCount: '',
            toggleCustomerId: '',
            showDialogBox: false,
            toggleCustomerStatus: '',
            currentPage: 0
        }
    }
    public componentDidMount(): void {
       
        this.fetchAllInactiveRegistrations();
        
    }

    public fetchAllInactiveRegistrations = (page: any = 0, limit: any = this.state.pageSize) => {
        this.setState({showLoader: true,currentPage: page});
        let data = {
            "hierarchies": this.props.user.selectedHierarchyIds,
            "filter": this.state.filter,
            "limit": limit,
            "page": page + 1,
        }
        axios.post('allInactiveCustomers', data, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
            if (response.data.success) {
                this.setState({showLoader: false});
                let list = [...response.data.data.data];
                // console.log("list", list);
                this.setState({inactive_registrations_data: [...list], rowCount: response.data.data.total});
            } else {
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                } 
            }
        }).catch((error) => {
            this.setState({showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public toggleCustomerStatus = () => {
        let data = {
            'hierarchies': this.props.user.selectedHierarchyIds,
            'customer_id': this.state.toggleCustomerId,
        }
        axios.post('toggleCustomerStatus', data, {headers: {'contentType': 'application/json'}}).then((response: any) => {
            if(response.data.success){
                toast.success(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchAllInactiveRegistrations();
                this.setState({showDialogBox: false, toggleCustomerId: '', toggleCustomerStatus: ''});
            } else {
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
                this.setState({showDialogBox: false, toggleCustomerId: '', toggleCustomerStatus: ''});
            }
        })
    }

    handleSearch = debounce((page: number = 0, limit: number = this.state.pageSize) => {
        this.fetchAllInactiveRegistrations(page,limit);
      }, 800);

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);
        const renderMaskedCell = (params: GridCellParams) => (
            <Box
                component="span"
                sx={isUatEnvironment ? {
                    filter: 'blur(4px)',
                    opacity: 0.5,
                    userSelect: 'none',
                } : undefined}
            >
                {params.value}
            </Box>
        );

        const toggleCustomerStatus = (id: any, status: any) => {
            this.setState({toggleCustomerStatus: status, toggleCustomerId: id, showDialogBox: true});
        }

        const columns = [
            {
                headerName: "ID",
                field: "id",
                width: 100,
              },
              {
                headerName: "Customer Name",
                field: "name",
                width: 150,
                renderCell: renderMaskedCell,
              },
              {
                headerName: "Mobile",
                field: "phone",
                width: 150,
                renderCell: renderMaskedCell,
              },
              {
                headerName: "Email",
                field: "email",
                width: 200,
                renderCell: renderMaskedCell,
              },
              {
                headerName: "H.No",
                field: "h_no",
                width: 200,
                renderCell: renderMaskedCell,
              },
              {
                headerName: "Community",
                field: "community",
                width: 150,
                renderCell: renderMaskedCell,
              },
              {
                headerName: "Status",
                field: "is_active",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <Button
                        variant={params.row.is_active == 1 ? "contained" : "outlined"}
                        size="small"
                        className="float-right"
                        color={params.row.is_active == 1 ? 'success' : 'error'}
                        // tabIndex={params.hasFocus ? 0 : -1}
                        onClick={() => toggleCustomerStatus(params.row.id, params.row.is_active)}
                        >
                        {params.row.is_active == 1 ? "Active" : "Inactive"}
                    </Button>
                )
              },
            // {
            //     headerName: "Actions",
            //     field: 'actions',
            //     type: 'actions',
            //     getActions: (params: GridRowParams) => [
            //         <GridActionsCellItem
            //             // icon={<FileCopyIcon />}    
            //             label="Edit Customer"
            //             onClick={() => console.log(params.id)}
            //             showInMenu
            //         />,
            //         // <GridActionsCellItem
                    //     label="Delete Customer"
                    //     onClick={() => console.log(params.id)}
                    //     showInMenu
                    // />
            //     ]
            // }
          ];
          

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <NeighbourhoodHeader user={this.props.user}/>
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title={<>
                                    <Grid container spacing={2}>
                                        <Grid item md={3} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("List of Customers")}</Typography>
                                        </Grid>
                                        
                                        <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <TextField
                                                    id="filter-input"
                                                    label={t("Search")}
                                                    name="filter"
                                                    value={this.state.filter}
                                                    onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.handleSearch())}
                                                    fullWidth={true}
                                                    size="small"
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </>
                                }
                                className="text-left"
                            />

                            <CardContent>
                                <DataGrid
                                    aria-label="List of Barcoded Bags"
                                    columns={columns}
                                    rows={this.state.inactive_registrations_data}
                                    pageSize={this.state.pageSize}
                                    rowCount={this.state.rowCount}
                                    onPageChange={(page) => this.fetchAllInactiveRegistrations(page)}
                                    onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize }, () => this.fetchAllInactiveRegistrations(0, newPageSize))}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    autoHeight={true}
                                    pagination
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                        Pagination: () => (
                                            <CustomPagination
                                                count={Math.ceil(this.state.rowCount / this.state.pageSize)}
                                                page={this.state.currentPage+1}
                                                onChange={(event, page) => this.fetchAllInactiveRegistrations(page-1)}
                                                
                                            />
                                        )
                                    }}
                                    // onRowClick={(params: GridRowParams) => {
                                    //     this.props.history.push('/neighbourhood/customers/' + params.id)
                                    // }}
                                    // className="clickableList"
                                    paginationMode="server"
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Dialog
                    open={this.state.showDialogBox}
                    onClose={() => this.setState({ showDialogBox: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Are you sure ? You want to")} {this.state.toggleCustomerStatus == 'active' ? t("Inactivate") : t("Activate")} {t("this customer?")}
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={() => this.setState({ showDialogBox: false, toggleCustomerId: '', toggleCustomerStatus: '' })}>{t("Cancel")}</Button>
                        <Button onClick={() => this.toggleCustomerStatus()} autoFocus>{this.state.toggleCustomerStatus == 'active' ? "Inactivate" : "Activate"}</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default withRouter(withTranslation()(InactiveRegistrations))
